import clsx from 'clsx';

export const EnvelopesIcon = () => {
  return (
    <svg
      width="219"
      height="219"
      viewBox="0 0 219 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="109.5" cy="109.5" r="109.5" fill="#D9C47D" />
      <path
        d="M66.1329 59.2097V103.809H48.293V161.789H124.112V143.949H173.172V85.9695H141.952V59.2097H66.1329ZM75.0528 68.1297H133.032V85.9695H92.8927V103.809H75.0528V68.1297ZM101.813 94.8895H164.252V135.029H124.112V103.809H101.813V94.8895ZM141.952 103.809V112.729H155.332V103.809H141.952ZM57.2129 112.729H66.1329H97.3527H115.193V117.695L88.2585 134.437C87.0142 135.213 85.3957 135.217 84.147 134.437L57.2129 117.703V112.729ZM115.193 128.2V152.869H57.2129V128.209L79.4344 142.015C81.5216 143.313 83.8657 143.967 86.2027 143.967C88.5398 143.967 90.8796 143.313 92.9624 142.007L115.193 128.2Z"
        fill="white"
      />
    </svg>
  );
};

export const ThumbsUpIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="219"
      height="219"
      viewBox="0 0 219 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {/* <circle cx="109.5" cy="109.5" r="109.5" fill="#D9C47D" /> */}
      <path
        d="M112.615 51.5938L111.199 52.8682L80.4717 83.3125H59.6562V155.812H135.979C142.369 155.812 147.945 151.299 149.29 145.051L159.061 99.7383C160.848 91.3661 154.299 83.3125 145.75 83.3125H119.695L120.545 79.9141C121.465 79.2061 122.049 78.9052 123.377 77.082C125.501 74.1792 127.625 69.6834 127.625 63.6299C127.625 57.1693 121.784 51.5938 114.456 51.5938H112.615ZM115.872 61.0811C117.784 61.4528 118.562 62.2316 118.562 63.6299C118.562 67.7186 117.323 70.2498 116.155 71.8428C114.987 73.4358 114.173 73.8252 114.173 73.8252L112.615 74.6748L112.049 76.5156L109.358 86.7109L107.942 92.375H145.75C148.741 92.375 150.759 94.9769 150.14 97.8975L140.511 143.21C140.051 145.334 138.139 146.75 135.979 146.75H86.8438V89.6846L115.872 61.0811ZM68.7188 92.375H77.7812V146.75H68.7188V92.375Z"
        fill="gray"
      />
    </svg>
  );
};

export const HazardIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="96"
      height="82"
      viewBox="0 0 96 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.557442 81.728L48.2293 0.728022L95.9012 81.728H0.557442ZM48.2293 72.4116C50.0809 72.4116 51.6629 71.7554 52.9754 70.4429C54.3113 69.1069 54.9793 67.5132 54.9793 65.6616C54.9793 63.8101 54.3113 62.228 52.9754 60.9155C51.6629 59.603 50.0809 58.9468 48.2293 58.9468C46.3778 58.9468 44.784 59.603 43.4481 60.9155C42.1356 62.228 41.4793 63.8101 41.4793 65.6616C41.4793 67.5132 42.1356 69.1069 43.4481 70.4429C44.784 71.7554 46.3778 72.4116 48.2293 72.4116ZM43.3074 51.4233H53.1512L53.7137 27.728H42.7449L43.3074 51.4233Z"
        fill="#D9C47D"
      />
    </svg>
  );
};

export const ChThumbsUpIcon = () => {
  return (
    <svg
      width="219"
      height="219"
      viewBox="0 0 219 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="109.5" cy="109.5" r="109.5" fill="#006367" />
      <path
        d="M112.615 51.5938L111.199 52.8682L80.4717 83.3125H59.6562V155.812H135.979C142.369 155.812 147.945 151.299 149.29 145.051L159.061 99.7383C160.848 91.3661 154.299 83.3125 145.75 83.3125H119.695L120.545 79.9141C121.465 79.2061 122.049 78.9052 123.377 77.082C125.501 74.1792 127.625 69.6834 127.625 63.6299C127.625 57.1693 121.784 51.5938 114.456 51.5938H112.615ZM115.872 61.0811C117.784 61.4528 118.562 62.2316 118.562 63.6299C118.562 67.7186 117.323 70.2498 116.155 71.8428C114.987 73.4358 114.173 73.8252 114.173 73.8252L112.615 74.6748L112.049 76.5156L109.358 86.7109L107.942 92.375H145.75C148.741 92.375 150.759 94.9769 150.14 97.8975L140.511 143.21C140.051 145.334 138.139 146.75 135.979 146.75H86.8438V89.6846L115.872 61.0811ZM68.7188 92.375H77.7812V146.75H68.7188V92.375Z"
        fill="white"
      />
    </svg>
  );
};

export const ServerIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 4.52002V19.52H21.75V4.52002H2.25ZM3.75 6.02002H20.25V9.02002H3.75V6.02002ZM5.25 6.77002V8.27002H11.25V6.77002H5.25ZM18 6.77002C17.5869 6.77002 17.25 7.10693 17.25 7.52002C17.25 7.93311 17.5869 8.27002 18 8.27002C18.4131 8.27002 18.75 7.93311 18.75 7.52002C18.75 7.10693 18.4131 6.77002 18 6.77002ZM3.75 10.52H20.25V13.52H3.75V10.52ZM5.25 11.27V12.77H11.25V11.27H5.25ZM18 11.27C17.5869 11.27 17.25 11.6069 17.25 12.02C17.25 12.4331 17.5869 12.77 18 12.77C18.4131 12.77 18.75 12.4331 18.75 12.02C18.75 11.6069 18.4131 11.27 18 11.27ZM3.75 15.02H20.25V18.02H3.75V15.02ZM5.25 15.77V17.27H11.25V15.77H5.25ZM18 15.77C17.5869 15.77 17.25 16.1069 17.25 16.52C17.25 16.9331 17.5869 17.27 18 17.27C18.4131 17.27 18.75 16.9331 18.75 16.52C18.75 16.1069 18.4131 15.77 18 15.77Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HandshakeIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4844 0.246541C13.0684 0.249471 12.6553 0.269979 12.2188 0.387166C11.7822 0.504354 11.3457 0.691854 10.8828 0.996541C10.3086 0.659627 9.75195 0.381307 9.21875 0.316854C8.55664 0.234823 7.94141 0.278768 7.22656 0.293416C6.37988 0.310995 5.82617 0.744589 4.92969 1.09029C4.0332 1.43599 2.87891 1.76998 1.25 1.76998H0.5V8.98873L0.921875 9.19967L2.30469 9.87935L7.22656 15.3637L7.25 15.3872C7.8125 15.9438 8.57129 16.0815 9.24219 16.0434C9.91309 16.0053 10.543 15.809 11.0469 15.5044C12.1543 14.8364 15.1719 12.7387 15.1719 12.7387L15.2422 12.6919L15.2891 12.645C15.6465 12.2905 15.8252 11.8569 15.9453 11.4028L18.8281 9.94967L20.9844 9.2231L21.5 9.05904V1.76998H20.75C19.124 1.76998 17.9668 1.41842 17.0703 1.06685C16.1738 0.715291 15.6289 0.287557 14.7734 0.269979C14.3164 0.26119 13.9004 0.243612 13.4844 0.246541ZM13.5078 1.74654C13.8447 1.74361 14.2344 1.76119 14.7266 1.76998C14.8057 1.77291 15.5264 2.08053 16.5312 2.4731C17.3809 2.80709 18.5615 3.10299 20 3.19967V7.98092L18.2656 8.56685H18.2188L18.1719 8.59029L15.8984 9.73873C15.7725 9.39596 15.5996 9.07955 15.3359 8.80123L15.2891 8.73092L12.1016 4.81685L11.6328 4.23092L11.0469 4.69967L9.03125 6.34029C8.35449 6.80904 7.80664 6.67428 7.25 6.4106C7.08887 6.33443 7.09766 6.31099 6.96875 6.2231L10.3906 3.38717L10.4375 3.34029C11.4541 2.33248 12.0781 1.98385 12.6172 1.84029C12.8867 1.76705 13.1709 1.74947 13.5078 1.74654ZM8.28125 1.76998C8.56836 1.76412 8.80859 1.76705 9.03125 1.79342C9.22754 1.81685 9.4502 1.98385 9.64062 2.05123C9.56445 2.12154 9.50879 2.16256 9.42969 2.23873C9.41211 2.25631 9.40039 2.26803 9.38281 2.2856L5.28125 5.68404L4.64844 6.19967L5.21094 6.7856C5.21094 6.7856 5.75293 7.37154 6.59375 7.76998C7.43457 8.16842 8.73242 8.394 9.89844 7.58248L9.94531 7.5356L11.3984 6.34029L14.1641 9.73873L14.1875 9.7856L14.2109 9.80904C14.7061 10.2983 14.6943 11.0688 14.2109 11.5669C14.2051 11.5727 14.2168 11.5844 14.2109 11.5903C14.2051 11.5932 14.1055 11.6518 14.0938 11.6606L13.1094 10.3247L11.8906 11.2153L12.8516 12.5044C12.4619 12.768 12.2861 12.9057 11.8672 13.184L10.8594 11.8247L9.64062 12.7153L10.6016 14.0044C10.5166 14.0571 10.3408 14.1743 10.2734 14.2153C10.0361 14.3588 9.5791 14.52 9.17188 14.5434C8.78809 14.5639 8.49512 14.476 8.35156 14.3559L8.32812 14.3325L3.3125 8.77779L3.21875 8.6606L2 8.05123V3.19967C3.43262 3.10592 4.62207 2.82174 5.46875 2.49654C6.4707 2.11275 7.18555 1.79635 7.27344 1.79342C7.65723 1.78463 7.99414 1.77584 8.28125 1.76998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FolderPlusIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 2.27002V3.02002V21.02V21.77H5.25H18.75H19.5V21.02V11.5981L20.7891 10.3091L21 10.0747V9.77002V3.02002V2.27002H20.25H18H17.25H5.25H4.5ZM6 3.77002H16.5V9.77002V10.0747L16.7109 10.3091L18 11.5981V20.27H6V3.77002ZM18 3.77002H19.5V9.44189L18.75 10.1919L18 9.44189V3.77002ZM11.25 9.02002V11.27H9V12.77H11.25V15.02H12.75V12.77H15V11.27H12.75V9.02002H11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const InfoCircleIcon = ({ color = '#515151' }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.27002C6.62402 2.27002 2.25 6.64404 2.25 12.02C2.25 17.396 6.62402 21.77 12 21.77C17.376 21.77 21.75 17.396 21.75 12.02C21.75 6.64404 17.376 2.27002 12 2.27002ZM12 3.77002C16.5645 3.77002 20.25 7.45557 20.25 12.02C20.25 16.5845 16.5645 20.27 12 20.27C7.43555 20.27 3.75 16.5845 3.75 12.02C3.75 7.45557 7.43555 3.77002 12 3.77002ZM11.25 7.52002V9.02002H12.75V7.52002H11.25ZM11.25 10.52V16.52H12.75V10.52H11.25Z"
        fill={color}
      />
    </svg>
  );
};

export const DownloadsIcon = ({ isSelected = false, type = 'text-black' }) => {
  return (
    <svg
      className={clsx(`${type}`)}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.25 3.02002V15.4419L7.28906 11.481L6.21094 12.5591L11.4609 17.8091L12 18.3247L12.5391 17.8091L17.7891 12.5591L16.7109 11.481L12.75 15.4419V3.02002H11.25ZM5.25 19.52V21.02H18.75V19.52H5.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownArrowIcon = ({ isSelected = false }) => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.83268 8.99967C2.83268 10.3825 2.94673 11.6572 3.08186 12.6804C3.20347 13.6012 3.89782 14.2956 4.81864 14.4172C5.8418 14.5523 7.11652 14.6663 8.49935 14.6663C9.88218 14.6663 11.1569 14.5523 12.1801 14.4172C13.1009 14.2956 13.7952 13.6012 13.9168 12.6804C14.052 11.6572 14.166 10.3825 14.166 8.99967C14.166 7.61684 14.052 6.34212 13.9168 5.31897C13.7952 4.39815 13.1009 3.7038 12.1801 3.58218C11.1569 3.44705 9.88218 3.33301 8.49935 3.33301C7.11652 3.33301 5.8418 3.44705 4.81864 3.58218C3.89782 3.7038 3.20347 4.39815 3.08186 5.31897C2.94673 6.34212 2.83268 7.61684 2.83268 8.99967ZM1.67739 12.8659C1.8829 14.4219 3.07709 15.6161 4.63315 15.8216C5.70291 15.9629 7.04108 16.083 8.49935 16.083C9.95761 16.083 11.2958 15.9629 12.3655 15.8216C13.9216 15.6161 15.1158 14.4219 15.3213 12.8659C15.4626 11.7961 15.5827 10.4579 15.5827 8.99967C15.5827 7.54141 15.4626 6.20323 15.3213 5.13348C15.1158 3.57741 13.9216 2.38322 12.3655 2.17771C11.2958 2.03643 9.95761 1.91634 8.49935 1.91634C7.04108 1.91634 5.70291 2.03643 4.63315 2.17771C3.07709 2.38322 1.8829 3.57741 1.67739 5.13348C1.5361 6.20323 1.41602 7.54141 1.41602 8.99967C1.41602 10.4579 1.5361 11.7961 1.67739 12.8659Z"
        fill="#000000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.51997 7.43663C5.79659 7.16001 6.24508 7.16001 6.5217 7.43663L8.5 9.41493L10.4783 7.43663C10.7549 7.16001 11.2034 7.16001 11.48 7.43663C11.7567 7.71325 11.7567 8.16175 11.48 8.43837L9.00087 10.9175C8.72425 11.1942 8.27575 11.1942 7.99913 10.9175L5.51997 8.43837C5.24334 8.16175 5.24334 7.71325 5.51997 7.43663Z"
        fill="#000000"
      />
    </svg>
  );
};

export const XIcon = ({ className, color }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.17969 20.2447L20.2464 1.17806M20.2464 20.2447L1.17969 1.17806"
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  );
};

export const SettingsLineIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 9.02002C19.5523 9.02002 20 9.46774 20 10.02L20 21.02C20 21.5723 19.5523 22.02 19 22.02C18.4477 22.02 18 21.5723 18 21.02L18 10.02C18 9.46774 18.4477 9.02002 19 9.02002Z"
        fill="currentColor"
      />
      <path
        d="M19 2.02002C19.5523 2.02002 20 2.46773 20 3.02002V6.02002C20 6.5723 19.5523 7.02002 19 7.02002C18.4477 7.02002 18 6.5723 18 6.02002V3.02002C18 2.46773 18.4477 2.02002 19 2.02002Z"
        fill="currentColor"
      />
      <path
        d="M13 3.02002C13 2.46773 12.5523 2.02002 12 2.02002C11.4477 2.02002 11 2.46773 11 3.02002L11 14.02C11 14.5723 11.4477 15.02 12 15.02C12.5523 15.02 13 14.5723 13 14.02L13 3.02002Z"
        fill="currentColor"
      />
      <path
        d="M13 18.02C13 17.4677 12.5523 17.02 12 17.02C11.4477 17.02 11 17.4677 11 18.02V21.02C11 21.5723 11.4477 22.02 12 22.02C12.5523 22.02 13 21.5723 13 21.02V18.02Z"
        fill="currentColor"
      />
      <path
        d="M6 3.02002C6 2.46774 5.55229 2.02002 5 2.02002C4.44772 2.02002 4 2.46773 4 3.02002L4 10.02C4 10.5723 4.44772 11.02 5 11.02C5.55228 11.02 6 10.5723 6 10.02L6 3.02002Z"
        fill="currentColor"
      />
      <path
        d="M6 14.02C6 13.4677 5.55229 13.02 5 13.02C4.44772 13.02 4 13.4677 4 14.02L4 21.02C4 21.5723 4.44772 22.02 5 22.02C5.55229 22.02 6 21.5723 6 21.02L6 14.02Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11.02C17.3431 11.02 16 9.67687 16 8.02002C16 6.36317 17.3431 5.02002 19 5.02002C20.6569 5.02002 22 6.36317 22 8.02002C22 9.67687 20.6569 11.02 19 11.02ZM19 9.02002C18.4477 9.02002 18 8.5723 18 8.02002C18 7.46773 18.4477 7.02002 19 7.02002C19.5523 7.02002 20 7.46773 20 8.02002C20 8.5723 19.5523 9.02002 19 9.02002Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.02C9 17.6769 10.3431 19.02 12 19.02C13.6569 19.02 15 17.6769 15 16.02C15 14.3632 13.6569 13.02 12 13.02C10.3431 13.02 9 14.3632 9 16.02ZM11 16.02C11 16.5723 11.4477 17.02 12 17.02C12.5523 17.02 13 16.5723 13 16.02C13 15.4677 12.5523 15.02 12 15.02C11.4477 15.02 11 15.4677 11 16.02Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.02C2 13.6769 3.34315 15.02 5 15.02C6.65685 15.02 8 13.6769 8 12.02C8 10.3632 6.65685 9.02002 5 9.02002C3.34315 9.02002 2 10.3632 2 12.02ZM4 12.02C4 12.5723 4.44772 13.02 5 13.02C5.55228 13.02 6 12.5723 6 12.02C6 11.4677 5.55228 11.02 5 11.02C4.44772 11.02 4 11.4677 4 12.02Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LockIcon = ({ bgColor = '#D9C47D' }) => {
  return (
    <svg
      width="147"
      height="146"
      viewBox="0 0 147 146"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[100px] h-[100px] md:w-[150px] md:h-[150px]">
      <circle cx="73.5" cy="73" r="73" fill={bgColor} />
      <path
        d="M73.5 41.0312C64.4912 41.0312 57.0938 48.4287 57.0938 57.4375V64.4688H50.0625V101.969H96.9375V64.4688H89.9062V57.4375C89.9062 48.4287 82.5088 41.0312 73.5 41.0312ZM73.5 45.7188C79.9545 45.7188 85.2188 50.983 85.2188 57.4375V64.4688H61.7812V57.4375C61.7812 50.983 67.0455 45.7188 73.5 45.7188ZM54.75 69.1562H92.25V97.2812H54.75V69.1562Z"
        fill="white"
      />
    </svg>
  );
};

export const BackIcon = ({ className }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('cursor-pointer mr-[5rem]', className)}>
      <path
        d="M1.55023e-07 13C6.95463e-08 20.168 5.83203 26 13 26C20.168 26 26 20.168 26 13C26 5.83203 20.168 2.40501e-07 13 1.55023e-07C5.83203 6.95463e-08 2.40501e-07 5.83203 1.55023e-07 13ZM2 13C2 6.91406 6.91406 2 13 2C19.0859 2 24 6.91406 24 13C24 19.0859 19.0859 24 13 24C6.91406 24 2 19.0859 2 13ZM6 13L10 17L10 14L20 14L20 12L10 12L10 9L6 13Z"
        fill="#191919"
      />
    </svg>
  );
};

export const RocketIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="219"
      height="219"
      viewBox="0 0 219 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="109.5" cy="109.5" r="109.5" fill="#D9C47D" />
      <path
        d="M153.769 55.125C150.661 55.125 146.332 55.2666 141.759 55.6914C132.612 56.5587 122.051 58.1163 115.505 64.7539C110.006 70.3295 98.6423 85.1268 88.1338 99.0215C86.0565 101.765 86.1438 101.712 84.2236 104.261L76.543 103.836C70.8348 103.535 65.3362 105.978 61.7402 110.491L52.3838 122.103L47.7754 128.05L55.0371 129.466L69.7002 132.439L86.877 149.856L89.8096 164.725L91.3457 172.088L97.0713 167.415L108.522 157.928C112.974 154.281 115.383 148.706 115.086 142.918L114.667 135.271C117.268 133.271 117.181 133.324 119.974 131.165C133.712 120.492 148.357 109.04 153.769 103.553C160.262 96.9683 161.711 86.1003 162.566 76.79C163.422 67.4797 162.985 59.5146 162.985 59.5146L162.846 55.4082L158.796 55.2666C158.796 55.2666 156.876 55.125 153.769 55.125ZM149.719 64.1875C151.499 64.1875 152.756 64.2937 154.048 64.3291C154.1 66.9664 154.205 69.71 153.629 75.9404C152.843 84.525 150.26 94.0831 147.345 97.0391C143.365 101.075 128.213 113.306 114.527 123.943C102.43 133.342 93.9117 139.944 91.4854 141.785L77.7998 127.908C79.6327 125.412 85.8994 116.739 95.1162 104.544C105.59 90.7024 117.687 75.2855 121.789 71.126C124.844 68.0284 134.165 65.4088 142.597 64.6123C145.651 64.3291 147.938 64.1875 149.719 64.1875ZM129.33 80.1885C124.338 80.1885 120.393 84.3303 120.393 89.3926C120.393 94.4548 124.338 98.5967 129.33 98.5967C134.323 98.5967 138.407 94.4548 138.407 89.3926C138.407 84.3303 134.323 80.1885 129.33 80.1885ZM75.9844 112.898L77.6602 113.04C74.9719 116.651 70.573 122.439 69.9795 123.235L63.9746 121.961L68.583 116.297C70.381 114.049 73.1216 112.739 75.9844 112.898ZM65.79 136.404C61.9672 140.281 59.7852 145.644 58.249 150.14C56.7129 154.635 56.0146 158.353 56.0146 158.353L54.6182 165.008L61.1816 163.733C61.1816 163.733 64.7427 163.114 69.1416 161.609C73.5405 160.105 78.8297 157.875 82.8271 153.821L76.543 147.449C74.553 149.467 70.6079 151.237 67.0469 152.547C68.4084 148.777 70.3984 144.493 72.0742 142.776L65.79 136.404ZM106.009 141.785L106.148 143.484C106.306 146.387 105.171 149.166 102.937 150.989L97.2109 155.662L95.9541 149.573C96.7396 148.989 102.448 144.493 106.009 141.785Z"
        fill="white"
      />
    </svg>
  );
};

export const CopyIcon = ({ color = '#757575' }) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#515151" />
      <path
        d="M22 15V15C22 14.0681 22 13.6022 21.8478 13.2346C21.6448 12.7446 21.2554 12.3552 20.7654 12.1522C20.3978 12 19.9319 12 19 12H16C14.1144 12 13.1716 12 12.5858 12.5858C12 13.1716 12 14.1144 12 16V19C12 19.9319 12 20.3978 12.1522 20.7654C12.3552 21.2554 12.7446 21.6448 13.2346 21.8478C13.6022 22 14.0681 22 15 22V22"
        stroke="#F6F6F6"
        strokeWidth="1.5"
      />
      <rect x="18" y="18" width="10" height="10" rx="2" stroke="#F6F6F6" strokeWidth="1.5" />
    </svg>
  );
};

export const WhiteDownloadsIcon = () => {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
        fill="white"
      />
    </svg>
  );
};

export const AboutUsIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
        stroke="#191919"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16.5V12.5"
        fill="currentColor"
        stroke="#191919"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.5H12.01"
        fill="currentColor"
        stroke="#191919"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ContactIcon = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black')}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1822_38354)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
          d="M4.64757 2.85243C5.9385 1.5615 8.07351 1.71323 9.16889 3.17375L10.9872 5.59811C11.8829 6.79247 11.7642 8.46376 10.7085 9.51943L9.36792 10.86C9.49784 11.1982 9.92552 11.9402 11.2279 13.2426C12.5303 14.545 13.2724 14.9727 13.6106 15.1026L14.9511 13.7621C16.0068 12.7064 17.6781 12.5876 18.8724 13.4834L21.2968 15.3017C22.7573 16.3971 22.9091 18.5321 21.6181 19.823C21.1984 20.2427 21.1274 20.3137 20.427 21.0141C19.7132 21.7279 18.1976 22.3951 16.663 22.4618C14.2617 22.5662 11 21.5 6.98528 17.4853C2.97061 13.4706 1.90434 10.2088 2.00875 7.80751C2.06683 6.47171 2.49152 5.00458 3.46205 4.04912C4.15685 3.34315 4.24721 3.25279 4.64757 2.85243ZM4.00686 7.89439C3.93449 9.55893 4.636 12.3076 8.3995 16.0711C12.163 19.8346 14.9116 20.5361 16.5762 20.4637C18.13 20.3961 18.9636 19.6453 19.0128 19.5999L20.2039 18.4088C20.6342 17.9785 20.5837 17.2668 20.0968 16.9017L17.6724 15.0834C17.2743 14.7848 16.7172 14.8244 16.3653 15.1763C15.8352 15.7065 15.4732 16.0737 14.7648 16.7795C13.2932 18.2456 10.7741 15.6172 9.81371 14.6569C8.93113 13.7743 6.24147 11.1752 7.68961 9.70989C7.69248 9.70701 8.08253 9.31696 9.29427 8.10522C9.64616 7.75333 9.68576 7.19623 9.38717 6.79811L7.56889 4.37375C7.20376 3.88691 6.49209 3.83633 6.06179 4.26664C5.66573 4.66269 5.21751 5.11091 4.87188 5.45894C4.16051 6.17523 4.04493 7.01879 4.00686 7.89439Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1822_38354">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PlusIcon = ({ bg = '#006367' }) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="16.5" fill={bg} />
      <path d="M17 8.5V25.5" stroke="white" strokeWidth="3" />
      <path d="M25.5 17L8.5 17" stroke="white" strokeWidth="3" />
    </svg>
  );
};

export const ModalBackIcon = ({ color = '#515151' }) => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="21" rx="5" fill={color} />
      <path d="M12.5 15L8 10.5L12.5 6" stroke="white" stroke-width="2" />
    </svg>
  );
};

export const ModalCloseIcon = ({ color = '#515151' }) => {
  return (
    <svg width="19" height="19" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="1"
        d="M1 1L13 13M13 13L25 25M13 13L25 1M13 13L1 25"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const EnglishIconSvg = () => {
  return (
    <i>
      <svg
        width="35"
        height="35"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.54774 8.60596C2.81962 10.8543 1.51655 13.4458 0.757812 16.261H12.2028L4.54774 8.60596Z"
          fill="#0052B4"
        />
        <path
          d="M43.2422 16.2609C42.4834 13.4458 41.1803 10.8543 39.4522 8.60596L31.7974 16.2609H43.2422Z"
          fill="#0052B4"
        />
        <path
          d="M0.757812 27.7393C1.51664 30.5544 2.81971 33.1458 4.54774 35.3941L12.2025 27.7393H0.757812Z"
          fill="#0052B4"
        />
        <path
          d="M35.3937 4.54783C33.1454 2.81971 30.554 1.51664 27.7388 0.757812V12.2027L35.3937 4.54783Z"
          fill="#0052B4"
        />
        <path
          d="M8.60596 39.4522C10.8543 41.1803 13.4458 42.4833 16.2609 43.2422V31.7974L8.60596 39.4522Z"
          fill="#0052B4"
        />
        <path
          d="M16.2608 0.757812C13.4457 1.51664 10.8543 2.81971 8.60596 4.54774L16.2608 12.2026V0.757812Z"
          fill="#0052B4"
        />
        <path
          d="M27.7393 43.2422C30.5544 42.4833 33.1458 41.1803 35.3941 39.4522L27.7393 31.7974V43.2422Z"
          fill="#0052B4"
        />
        <path
          d="M31.7974 27.7393L39.4522 35.3942C41.1803 33.1459 42.4834 30.5544 43.2422 27.7393H31.7974Z"
          fill="#0052B4"
        />
        <path
          d="M43.8138 19.1305H24.8697H24.8696V0.186227C23.9302 0.0639375 22.9726 0 22 0C21.0273 0 20.0698 0.0639375 19.1305 0.186227V19.1303V19.1304H0.186227C0.0639375 20.0698 0 21.0274 0 22C0 22.9727 0.0639375 23.9302 0.186227 24.8695H19.1303H19.1304V43.8138C20.0698 43.9361 21.0273 44 22 44C22.9726 44 23.9302 43.9361 24.8695 43.8138V24.8697V24.8696H43.8138C43.9361 23.9302 44 22.9727 44 22C44 21.0274 43.9361 20.0698 43.8138 19.1305Z"
          fill="#D80027"
        />
        <path
          d="M27.7393 27.7393L37.5564 37.5565C38.0079 37.1052 38.4386 36.6333 38.8496 36.1441L30.4447 27.7393H27.7393V27.7393Z"
          fill="#D80027"
        />
        <path
          d="M16.2606 27.7393H16.2604L6.44336 37.5563C6.8947 38.0078 7.36659 38.4386 7.85574 38.8495L16.2606 30.4445V27.7393Z"
          fill="#D80027"
        />
        <path
          d="M16.2607 16.2608V16.2606L6.44358 6.44336C5.99206 6.8947 5.56134 7.36659 5.15039 7.85574L13.5553 16.2607H16.2607V16.2608Z"
          fill="#D80027"
        />
        <path
          d="M27.7393 16.2608L37.5565 6.44349C37.1052 5.99198 36.6333 5.56126 36.1441 5.15039L27.7393 13.5553V16.2608Z"
          fill="#D80027"
        />
      </svg>
    </i>
  );
};

export const GermanIconSvg = () => {
  return (
    <i>
      <svg
        width="35"
        height="35"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_628_2308)">
          <path
            d="M1.36768 29.6522C4.47612 38.0298 12.5401 44.0001 21.9993 44.0001C31.4585 44.0001 39.5225 38.0298 42.6309 29.6522L21.9993 27.7393L1.36768 29.6522Z"
            fill="#FFDA44"
          />
          <path
            d="M21.9993 0C12.5401 0 4.47612 5.97025 1.36768 14.3479L21.9993 16.2608L42.6309 14.3478C39.5225 5.97025 31.4585 0 21.9993 0Z"
            fill="black"
          />
          <path
            d="M1.36789 14.3477C0.483598 16.731 -0.000488281 19.3087 -0.000488281 21.9998C-0.000488281 24.6908 0.483598 27.2686 1.36789 29.6519H42.6312C43.5155 27.2686 43.9995 24.6908 43.9995 21.9998C43.9995 19.3087 43.5155 16.731 42.6311 14.3477H1.36789Z"
            fill="#D80027"
          />
        </g>
        <defs>
          <clipPath id="clip0_628_2308">
            <rect width="44" height="44" fill="white" transform="translate(-0.000488281)" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const UpDownArrow = () => {
  return (
    <svg width="18" height="29" viewBox="0 0 18 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_578_11947)">
        <path d="M9 7L13.7631 12.25H4.23686L9 7Z" fill="#191919" />
        <path d="M9 21L4.23686 15.75L13.7631 15.75L9 21Z" fill="#191919" />
      </g>
      <defs>
        <filter
          id="filter0_d_578_11947"
          x="-0.5"
          y="0"
          width="19"
          height="29"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_578_11947" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_578_11947"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M15.7845 10.0969L10.722 15.1594C10.5634 15.3179 10.3485 15.407 10.1243 15.407C9.90013 15.407 9.68515 15.3179 9.52664 15.1594C9.36813 15.0009 9.27908 14.7859 9.27908 14.5617C9.27908 14.3376 9.36813 14.1226 9.52664 13.9641L13.1484 10.3437H2.8125C2.58872 10.3437 2.37411 10.2548 2.21588 10.0966C2.05764 9.93833 1.96875 9.72372 1.96875 9.49994C1.96875 9.27616 2.05764 9.06155 2.21588 8.90332C2.37411 8.74508 2.58872 8.65619 2.8125 8.65619H13.1484L9.52805 5.03369C9.36954 4.87518 9.28049 4.6602 9.28049 4.43603C9.28049 4.21187 9.36954 3.99689 9.52805 3.83838C9.68655 3.67987 9.90154 3.59082 10.1257 3.59082C10.3499 3.59082 10.5649 3.67987 10.7234 3.83838L15.7859 8.90088C15.8645 8.97937 15.9269 9.07263 15.9695 9.17531C16.012 9.27798 16.0338 9.38804 16.0337 9.49918C16.0335 9.61031 16.0115 9.72032 15.9687 9.8229C15.9259 9.92547 15.8633 10.0186 15.7845 10.0969Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PlusIcons = ({ isSelected = false }) => {
  return (
    <svg
      className={clsx('text-black group-hover:text-white', {
        'text-white': isSelected
      })}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="red"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 0V17M0 8.5H17" stroke="#999999" />
    </svg>
  );
};

export const ItalianIconSvg = () => {
  return (
    <i>
      <svg
        width="35"
        height="35"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_628_2313)">
          <path
            d="M21.9995 44C34.1498 44 43.9995 34.1503 43.9995 22C43.9995 9.84974 34.1498 0 21.9995 0C9.84925 0 -0.000488281 9.84974 -0.000488281 22C-0.000488281 34.1503 9.84925 44 21.9995 44Z"
            fill="#F0F0F0"
          />
          <path
            d="M43.9997 21.9998C43.9997 12.5406 38.0295 4.47661 29.6519 1.36816V42.6315C38.0295 39.5229 43.9997 31.459 43.9997 21.9998Z"
            fill="#D80027"
          />
          <path
            d="M-0.000488281 21.9998C-0.000488281 31.459 5.96976 39.5229 14.3474 42.6314V1.36816C5.96976 4.47661 -0.000488281 12.5406 -0.000488281 21.9998Z"
            fill="#6DA544"
          />
        </g>
        <defs>
          <clipPath id="clip0_628_2313">
            <rect width="44" height="44" fill="white" transform="translate(-0.000488281)" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const FrenchIconSvg = () => {
  return (
    <i>
      <svg
        width="35"
        height="35"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_628_2318)">
          <path
            d="M21.999 44C34.1493 44 43.999 34.1503 43.999 22C43.999 9.84974 34.1493 0 21.999 0C9.84876 0 -0.000976562 9.84974 -0.000976562 22C-0.000976562 34.1503 9.84876 44 21.999 44Z"
            fill="#F0F0F0"
          />
          <path
            d="M43.9992 21.9998C43.9992 12.5406 38.029 4.47661 29.6514 1.36816V42.6315C38.029 39.5229 43.9992 31.459 43.9992 21.9998Z"
            fill="#D80027"
          />
          <path
            d="M-0.000976562 21.9998C-0.000976562 31.459 5.96936 39.5229 14.3469 42.6314V1.36816C5.96936 4.47661 -0.000976562 12.5406 -0.000976562 21.9998Z"
            fill="#0052B4"
          />
        </g>
        <defs>
          <clipPath id="clip0_628_2318">
            <rect width="44" height="44" fill="white" transform="translate(-0.000976562)" />
          </clipPath>
        </defs>
      </svg>
    </i>
  );
};

export const HeadPhone = ({ isSelected = false }) => {
  return (
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={clsx('text-black')}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M12 4.25C7.45312 4.25 3.75 7.95312 3.75 12.5V18.5C3.75 19.7334 4.7666 20.75 6 20.75H8.25V14H5.25V12.5C5.25 8.76172 8.26172 5.75 12 5.75C15.7383 5.75 18.75 8.76172 18.75 12.5V14H15.75V20.75H18C19.2334 20.75 20.25 19.7334 20.25 18.5V12.5C20.25 7.95312 16.5469 4.25 12 4.25ZM5.25 15.5H6.75V19.25H6C5.5752 19.25 5.25 18.9248 5.25 18.5V15.5ZM17.25 15.5H18.75V18.5C18.75 18.9248 18.4248 19.25 18 19.25H17.25V15.5Z"
      />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={clsx('text-black')}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 6.25H5C4.44772 6.25 4 6.69772 4 7.25V19.25C4 19.8023 4.44772 20.25 5 20.25H19C19.5523 20.25 20 19.8023 20 19.25V7.25C20 6.69771 19.5523 6.25 19 6.25ZM5 4.25C3.34315 4.25 2 5.59315 2 7.25V19.25C2 20.9069 3.34315 22.25 5 22.25H19C20.6569 22.25 22 20.9069 22 19.25V7.25C22 5.59315 20.6569 4.25 19 4.25H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12.25C9.44772 12.25 9 12.6977 9 13.25C9 13.8023 9.44772 14.25 10 14.25H17C17.5523 14.25 18 13.8023 18 13.25C18 12.6977 17.5523 12.25 17 12.25H10ZM7 16.25C6.44772 16.25 6 16.6977 6 17.25C6 17.8023 6.44772 18.25 7 18.25H13C13.5523 18.25 14 17.8023 14 17.25C14 16.6977 13.5523 16.25 13 16.25H7Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.25C6.44772 2.25 6 2.69772 6 3.25V7.25C6 7.80228 6.44772 8.25 7 8.25C7.55228 8.25 8 7.80228 8 7.25V3.25C8 2.69772 7.55228 2.25 7 2.25ZM17 2.25C16.4477 2.25 16 2.69772 16 3.25V7.25C16 7.80228 16.4477 8.25 17 8.25C17.5523 8.25 18 7.80228 18 7.25V3.25C18 2.69772 17.5523 2.25 17 2.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Trash = ({ color = '#006367' }) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8594 4.375C14.3196 4.375 13.7677 4.56433 13.377 4.95508C12.9862 5.34582 12.7969 5.89771 12.7969 6.4375V7.46875H5.57812V9.53125H6.70605L8.67188 28.1904L8.76855 29.125H25.0752L25.1719 28.1904L27.1377 9.53125H28.2656V7.46875H21.0469V6.4375C21.0469 5.89771 20.8575 5.34582 20.4668 4.95508C20.076 4.56433 19.5242 4.375 18.9844 4.375H14.8594ZM14.8594 6.4375H18.9844V7.46875H14.8594V6.4375ZM8.80078 9.53125H25.043L23.2061 27.0625H10.6377L8.80078 9.53125ZM12.7969 12.625V23.9688H14.8594V12.625H12.7969ZM15.8906 12.625V23.9688H17.9531V12.625H15.8906ZM18.9844 12.625V23.9688H21.0469V12.625H18.9844Z"
        fill={color}
      />
    </svg>
  );
};

export const Setting = ({ color = '#006367' }) => {
  return (
    <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="21" cy="21.75" r="21" fill={color} />
      <circle cx="20.9986" cy="21.5792" r="3.75644" stroke="white" strokeWidth="1.5" />
      <path
        d="M19.0218 11.9293C19.6516 10.0236 22.3484 10.0236 22.9782 11.9293C23.6154 13.8572 25.7349 14.8608 27.6312 14.1603C29.525 13.4608 31.1878 15.5772 30.1045 17.219C28.9871 18.9126 29.5079 21.1966 31.2495 22.238C32.951 23.2553 32.3617 25.8774 30.364 26.0623C28.347 26.249 26.8811 28.0775 27.1489 30.089C27.41 32.0505 24.9879 33.2335 23.584 31.7836C22.1747 30.328 19.8253 30.328 18.416 31.7836C17.0121 33.2335 14.59 32.0505 14.8511 30.089C15.1189 28.0775 13.653 26.249 11.636 26.0623C9.63825 25.8774 9.04897 23.2553 10.7505 22.238L10.3656 21.5943L10.7505 22.238C12.4921 21.1966 13.0129 18.9126 11.8955 17.219C10.8122 15.5772 12.475 13.4608 14.3688 14.1603C16.2651 14.8608 18.3846 13.8572 19.0218 11.9293Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="16"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.55,1H6.46C3.45,1,1,3.44,1,6.44v7.12c0,3,2.45,5.44,5.46,5.44h7.08c3.02,0,5.46-2.44,5.46-5.44V6.44 C19.01,3.44,16.56,1,13.55,1z M17.5,14c0,1.93-1.57,3.5-3.5,3.5H6c-1.93,0-3.5-1.57-3.5-3.5V6c0-1.93,1.57-3.5,3.5-3.5h8 c1.93,0,3.5,1.57,3.5,3.5V14z"></path>
      <circle cx="14.87" cy="5.26" r="1.09"></circle>
      <path d="M10.03,5.45c-2.55,0-4.63,2.06-4.63,4.6c0,2.55,2.07,4.61,4.63,4.61c2.56,0,4.63-2.061,4.63-4.61 C14.65,7.51,12.58,5.45,10.03,5.45L10.03,5.45L10.03,5.45z M10.08,13c-1.66,0-3-1.34-3-2.99c0-1.65,1.34-2.99,3-2.99s3,1.34,3,2.99 C13.08,11.66,11.74,13,10.08,13L10.08,13L10.08,13z"></path>
    </svg>
  );
};

export const FacebookIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z"></path>
    </svg>
  );
};

export const LinkdInIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z"></path>
      <path d="M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z"></path>
    </svg>
  );
};

export const TikTokIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.24,6V8.82a6.79,6.79,0,0,1-4-1.28v5.81A5.26,5.26,0,1,1,8,8.1a4.36,4.36,0,0,1,.72.05v2.9A2.57,2.57,0,0,0,7.64,11a2.4,2.4,0,1,0,2.77,2.38V2h2.86a4,4,0,0,0,1.84,3.38A4,4,0,0,0,17.24,6Z"></path>
    </svg>
  );
};

export const TwitterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
      <path
        d="M13.481 1.34766H15.8706L10.6501 7.3143L16.7916 15.4336H11.9829L8.21653 10.5093L3.90696 15.4336H1.51597L7.09977 9.05156L1.20825 1.34766H6.13904L9.54349 5.84864L13.481 1.34766ZM12.6424 14.0033H13.9665L5.41957 2.70279H3.9987L12.6424 14.0033Z"
        fill="#006367"></path>
    </svg>
  );
};

export const YoutubeIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M15,4.1c1,0.1,2.3,0,3,0.8c0.8,0.8,0.9,2.1,0.9,3.1C19,9.2,19,10.9,19,12c-0.1,1.1,0,2.4-0.5,3.4c-0.5,1.1-1.4,1.5-2.5,1.6 c-1.2,0.1-8.6,0.1-11,0c-1.1-0.1-2.4-0.1-3.2-1c-0.7-0.8-0.7-2-0.8-3C1,11.8,1,10.1,1,8.9c0-1.1,0-2.4,0.5-3.4C2,4.5,3,4.3,4.1,4.2 C5.3,4.1,12.6,4,15,4.1z M8,7.5v6l5.5-3L8,7.5z"></path>
    </svg>
  );
};

export const PlusIcon2 = ({ className, color = '#006367' }) => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M0.603516 4.50024H7.93512"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26953 0.728271V8.27104"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PLusIconWithBorder = ({ color = '#515151' }) => {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1.5" width="17" height="17" rx="4" stroke={color} strokeWidth="2" />
      <path
        d="M9.5 5.5L9.5 14.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14 10L5 10"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIconWithBar = ({ color = '#515151' }) => {
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4987 10.5L9.99697 11.0575L10.4987 11.509L11.0004 11.0575L10.4987 10.5ZM11.2487 3.75C11.2487 3.33579 10.9129 3 10.4987 3C10.0845 3 9.7487 3.33579 9.7487 3.75L11.2487 3.75ZM5.83031 7.30747L9.99697 11.0575L11.0004 9.94253L6.83375 6.19253L5.83031 7.30747ZM11.0004 11.0575L15.1671 7.30747L14.1636 6.19253L9.99697 9.94253L11.0004 11.0575ZM11.2487 10.5L11.2487 3.75L9.7487 3.75L9.7487 10.5L11.2487 10.5Z"
        fill={color}
      />
      <path
        d="M4.66797 12L4.66797 12.75C4.66797 13.5784 5.41416 14.25 6.33464 14.25L14.668 14.25C15.5884 14.25 16.3346 13.5784 16.3346 12.75V12"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const MinusIcon = ({ className, color = '#006367' }) => {
  return (
    <svg
      width="9"
      height="1"
      viewBox="0 0 9 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M1.14258 0.500244H8.47418"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M10.084 4.16675H3.66732C3.18109 4.16675 2.71477 4.3599 2.37096 4.70372C2.02714 5.04754 1.83398 5.51385 1.83398 6.00008V18.8334C1.83398 19.3196 2.02714 19.786 2.37096 20.1298C2.71477 20.4736 3.18109 20.6667 3.66732 20.6667H16.5007C16.9869 20.6667 17.4532 20.4736 17.797 20.1298C18.1408 19.786 18.334 19.3196 18.334 18.8334V12.4167"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.959 2.79171C17.3237 2.42704 17.8183 2.22217 18.334 2.22217C18.8497 2.22217 19.3443 2.42704 19.709 2.79171C20.0737 3.15638 20.2785 3.65099 20.2785 4.16671C20.2785 4.68244 20.0737 5.17704 19.709 5.54171L11.0007 14.25L7.33398 15.1667L8.25065 11.5L16.959 2.79171Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GroupIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
      <path
        d="M19.0867 37.8187C29.3518 37.8187 37.6733 29.4873 37.6733 19.2101C37.6733 8.9329 29.3518 0.601562 19.0867 0.601562C8.82154 0.601562 0.5 8.9329 0.5 19.2101C0.5 29.4873 8.82154 37.8187 19.0867 37.8187Z"
        fill="#006266"
      />
      <path
        d="M13.5737 28.8297L22.552 21.4178L24.7572 9.74805L15.6214 17.3176L13.5737 28.672V28.8297ZM22.3945 13.8482L21.1344 20.3139L19.2442 19.21L17.3541 18.1061L22.3945 13.8482Z"
        fill="white"
      />
      <path
        d="M19.0867 32.7723C26.4811 32.7723 32.4754 26.7709 32.4754 19.3679C32.4754 11.9648 26.4811 5.96338 19.0867 5.96338C11.6923 5.96338 5.698 11.9648 5.698 19.3679C5.698 26.7709 11.6923 32.7723 19.0867 32.7723Z"
        stroke="white"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export const PopupCrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63 63"
      fill="none"
      className="h-[35px] w-[35px] md:h-[50px] md:w-[50px] ">
      <circle cx="31.5" cy="31.5" r="31.5" fill="#E5EFEF" />
      <path d="M21 42L41.2222 21M21.7778 21L42 42" stroke="#006367" strokeWidth="4" />
    </svg>
  );
};

export const BackIconLogin = () => {
  return (
    <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.625 18C0.625 27.856 8.64404 35.875 18.5 35.875C28.356 35.875 36.375 27.856 36.375 18C36.375 8.14404 28.356 0.125 18.5 0.125C8.64404 0.125 0.625 8.14404 0.625 18ZM3.375 18C3.375 9.63184 10.1318 2.875 18.5 2.875C26.8682 2.875 33.625 9.63184 33.625 18C33.625 26.3682 26.8682 33.125 18.5 33.125C10.1318 33.125 3.375 26.3682 3.375 18ZM8.875 18L14.375 23.5L14.375 19.375L28.125 19.375L28.125 16.625L14.375 16.625L14.375 12.5L8.875 18Z"
        fill="#006367"
      />
    </svg>
  );
};

export const PointerIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="74"
      height="73"
      viewBox="0 0 74 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12412_18061)">
        <path
          d="M20.6941 18.7411C18.3578 20.0389 17.6015 23.0571 19.0202 25.4212L29.2109 42.4027L27.6855 41.9322L27.1416 41.815C24.5104 41.0678 21.8355 42.5535 21.1926 45.1195C20.5496 47.6854 22.1739 50.3921 24.8052 51.1393L24.8321 51.1843L43.4463 56.3588L43.5621 56.3544L43.6604 56.4196C46.4478 56.8106 49.4726 56.4258 52.2196 54.8999L54.6613 53.5436C61.1043 49.9649 63.1421 41.8322 59.2296 35.3125L52.4897 24.0814C51.071 21.7173 47.976 20.8383 45.6396 22.136C45.0347 22.472 44.5753 22.9518 44.1952 23.4774C42.6069 21.8664 40.0795 21.3908 38.0984 22.4913C37.0107 23.0955 36.2713 24.0827 35.931 25.1926C34.7618 24.9211 33.5034 25.0436 32.4157 25.6478C31.9163 25.9252 31.5086 26.2939 31.1568 26.7064L27.5442 20.6865C26.1255 18.3224 23.0304 17.4434 20.6941 18.7411ZM22.4195 21.6163C23.2075 21.1786 24.2244 21.4674 24.7029 22.2648L34.1926 38.0782L37.034 36.5L33.5832 30.7496C33.1046 29.9522 33.3531 28.9606 34.1411 28.5229C34.9291 28.0852 35.946 28.374 36.4245 29.1714L39.8753 34.9217L42.7166 33.3435L39.2658 27.5932C38.7873 26.7957 39.0358 25.8042 39.8238 25.3665C40.6118 24.9287 41.6286 25.2175 42.1072 26.0149L45.558 31.7653L48.5325 30.113L46.8071 27.2379C46.3285 26.4405 46.577 25.4489 47.365 25.0112C48.1531 24.5735 49.1699 24.8622 49.6484 25.6596L56.3883 36.8908C59.3774 41.8718 57.8583 47.9343 52.9359 50.6685L50.4941 52.0248C48.4131 53.1807 46.1635 53.4269 43.9899 53.1218L25.5898 48.008C24.573 47.7193 24.1551 47.0229 24.4036 46.0314C24.652 45.0398 25.3402 44.6576 26.357 44.9463L36.204 47.7428L21.8616 23.843C21.383 23.0456 21.6315 22.054 22.4195 21.6163Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12412_18061">
          <rect
            width="52.0037"
            height="53.6504"
            fill="white"
            transform="matrix(0.874194 -0.485576 0.514564 0.857452 0.5 26.1245)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OnlineWorkshopIcon = ({ color = '#515151' }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.334 4H4.00065C2.52789 4 1.33398 5.19391 1.33398 6.66667V22.6667C1.33398 24.1394 2.52789 25.3333 4.00065 25.3333H15.334C15.7022 25.3333 16.0007 25.0349 16.0007 24.6667V18.6667C16.0007 17.1939 17.1946 16 18.6673 16H27.334C27.7022 16 28.0006 15.7015 28.0006 15.3333V6.66667C28.0006 5.19391 26.8067 4 25.334 4Z"
        fill={color}
      />
      <path
        d="M18.666 20.0003C18.666 19.2639 19.263 18.667 19.9993 18.667H29.3327C30.0691 18.667 30.666 19.2639 30.666 20.0003V26.667C30.666 27.4034 30.0691 28.0003 29.3327 28.0003H19.9993C19.263 28.0003 18.666 27.4034 18.666 26.667V20.0003Z"
        fill={color}
      />
    </svg>
  );
};

export const InPersonWorkshopIcon = ({ color = '#515151' }) => {
  return (
    <svg width="35" height="32" viewBox="0 0 35 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9392 18.0634C32.3571 17.3885 31.3571 17.4232 30.5752 17.8512C29.3653 18.5135 27.9766 18.89 26.5 18.89C25.0234 18.89 23.6347 18.5135 22.4248 17.8512C21.6429 17.4232 20.6429 17.3885 20.0608 18.0634C18.7765 19.5524 18 21.4916 18 23.6122V24.5567C18 25.5999 18.8457 26.4455 19.8889 26.4455H33.1111C34.1543 26.4455 35 25.5999 35 24.5567V23.6122C35 21.4916 34.2235 19.5524 32.9392 18.0634Z"
        fill={color}
      />
      <path
        d="M31.2218 10.3892C31.2218 12.9972 29.1076 15.1114 26.4996 15.1114C23.8916 15.1114 21.7773 12.9972 21.7773 10.3892C21.7773 7.7812 23.8916 5.66699 26.4996 5.66699C29.1076 5.66699 31.2218 7.7812 31.2218 10.3892Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4088 18.5932C22.5356 17.5807 21.0357 17.6329 19.8628 18.2748C18.0479 19.2682 15.9649 19.833 13.75 19.833C11.5351 19.833 9.45209 19.2682 7.63716 18.2748C6.46432 17.6329 4.96442 17.5807 4.09117 18.5932C2.16482 20.8267 1 23.7355 1 26.9164V28.333C1 29.8978 2.26853 31.1664 3.83333 31.1664H23.6667C25.2315 31.1664 26.5 29.8978 26.5 28.333V26.9164C26.5 23.7355 25.3352 20.8267 23.4088 18.5932Z"
        fill={color}
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M20.3327 7.08333C20.3327 10.7192 17.3852 13.6667 13.7493 13.6667C10.1135 13.6667 7.16602 10.7192 7.16602 7.08333C7.16602 3.44746 10.1135 0.5 13.7493 0.5C17.3852 0.5 20.3327 3.44746 20.3327 7.08333Z"
        fill={color}
        stroke="white"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg width="33" height="34" viewBox="0 0 33 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.4375 4.625C13.8977 4.625 13.3458 4.81433 12.9551 5.20508C12.5643 5.59582 12.375 6.14771 12.375 6.6875V7.71875H5.15625V9.78125H6.28418L8.25 28.4404L8.34668 29.375H24.6533L24.75 28.4404L26.7158 9.78125H27.8438V7.71875H20.625V6.6875C20.625 6.14771 20.4357 5.59582 20.0449 5.20508C19.6542 4.81433 19.1023 4.625 18.5625 4.625H14.4375ZM14.4375 6.6875H18.5625V7.71875H14.4375V6.6875ZM8.37891 9.78125H24.6211L22.7842 27.3125H10.2158L8.37891 9.78125ZM12.375 12.875V24.2188H14.4375V12.875H12.375ZM15.4688 12.875V24.2188H17.5312V12.875H15.4688ZM18.5625 12.875V24.2188H20.625V12.875H18.5625Z"
        fill="black"
      />
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00065 13.3333C10.9462 13.3333 13.334 10.9454 13.334 7.99992C13.334 5.0544 10.9462 2.66659 8.00065 2.66659C5.05513 2.66659 2.66732 5.0544 2.66732 7.99992C2.66732 10.9454 5.05513 13.3333 8.00065 13.3333ZM8.00065 14.6666C11.6825 14.6666 14.6673 11.6818 14.6673 7.99992C14.6673 4.31802 11.6825 1.33325 8.00065 1.33325C4.31875 1.33325 1.33398 4.31802 1.33398 7.99992C1.33398 11.6818 4.31875 14.6666 8.00065 14.6666Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00065 4.66675C7.63246 4.66675 7.33398 4.96522 7.33398 5.33341C7.33398 5.7016 7.63246 6.00008 8.00065 6.00008C8.36884 6.00008 8.66732 5.7016 8.66732 5.33341C8.66732 4.96522 8.36884 4.66675 8.00065 4.66675ZM8.00065 7.33341C7.63246 7.33341 7.33398 7.63189 7.33398 8.00008V10.6667C7.33398 11.0349 7.63246 11.3334 8.00065 11.3334C8.36884 11.3334 8.66732 11.0349 8.66732 10.6667V8.00008C8.66732 7.63189 8.36884 7.33341 8.00065 7.33341Z"
        fill="black"
      />
    </svg>
  );
};
